// @vue/component
export default {
  name: 'BlacklistFilters',

  props: {
    projectList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      searchParams: {
        project: '',
        blocked_num: '',
      },
    };
  },
  methods: {
    submitSearchForm() {
      this.$store.dispatch('blacklist/filterList', this.searchParams);
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    onlyNumber($event) {
      let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
        $event.preventDefault();
      }
    },
  },

};
